/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  presentPrompt?: boolean
  prompt?: string
  file?: File
  generating?: ExactlyOneOf<{ loading: boolean; error: Error | string }>
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    file: undefined,
    generating: undefined,
    presentPrompt: false,
    prompt: undefined,
  }
}
